import styled from 'styled-components';
import { ButtonLabel, ButtonWrapper } from '@src/styles/styled/mixins';


export const Wrapper =  styled.div`
  ${ButtonWrapper}
`;

export const StyledLabel = styled.span`
  ${ButtonLabel}
`;

export const Warning = styled.div`
  display: inline-block;
  vertical-align: text-bottom;
  color: #faad14;
`;
